/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: System = 1, Google = 2, Outlook = 3, Zoom = 4, Manual = 5, Routemized = 6, InternalRoutemized = 7
 */
export enum Routemize_Constants_AppointmentSource {
    SYSTEM = 'System',
    GOOGLE = 'Google',
    OUTLOOK = 'Outlook',
    ZOOM = 'Zoom',
    MANUAL = 'Manual',
    ROUTEMIZED = 'Routemized',
    INTERNAL_ROUTEMIZED = 'InternalRoutemized',
}
